import React from "react";
import useStore from "../../../context/useStore";
import { modalActions } from "../../../context/actions/modalActions";
import AddRecipientToEp from "./AddRecipientToEp";
import AddRecipientToCrossInterview from "./AddRecipientToCrossInterview";
import MutationModal from "./MutationModal";
import EnrollToNextEpButton from "./EnrollToNextEpButton";
import ForceSynchroFTButton from "./ForceSynchroFTButton";
import SuspensionRemobilisationButton from "./SuspensionRemobilisationButton";
import DemanderSuspensionRemobilisationModal from "./DemanderSuspensionRemobilisationModal";

// Actions de la fiche allocataire — logique déplacée telle quelle depuis
// RecipientInfo (mêmes conditions, mêmes libellés, mêmes data-priv), rendue
// dans l'en-tête pour être visible sans déplier les informations.
export const PARTNERS_MUTATION_ALLOWED = ["ML_NORD", "ML_SUD", "ML_EST", "ML_OUEST"];
export const ROLES_CAN_MUTATE = ["SUPER_ADMIN", "ADMIN", "MANAGER_PARTNER", "AGENT_PARTNER"];

export function getOrganizationAfterMutation(recipient, partners = []) {
  const postalCodeTown = recipient.location?.postalCodeTown;
  return partners
    .filter((o) => PARTNERS_MUTATION_ALLOWED.includes(o.code))
    .find((z) => (z.postalCodeTowns || []).map((e) => e.toString()).includes(String(postalCodeTown)));
}

export const canSeeProcedureActions = (recipient) => !recipient.currentEP && !recipient.currentOrientation;

const RecipientActions = ({
  recipient,
  refresh = () => {},
  isSaving = false,
  isModal = false,
  unlockAccount,
  resendActivationMail,
  onSynchroForced = () => {},
}) => {
  const [state, dispatch] = useStore();
  const mActions = modalActions(state, dispatch);
  const role = state.auth?.user?.role;
  const constants = Array.isArray(state.constants.items) ? {} : state.constants.items;

  const organizationAfterMutation = getOrganizationAfterMutation(recipient, constants.PARTNERS || []);
  const lastOrientation = recipient.lastOrientation?.orientation;
  const procedureFree = canSeeProcedureActions(recipient);
  const canMutate = ROLES_CAN_MUTATE.includes(role);

  const openModal = (content) => mActions.updateModal({ isOpen: true, content });

  return (
    <>
      {!isSaving && (
        <EnrollToNextEpButton
          recipient={recipient}
          addRecipientToNextEp={() =>
            openModal(<AddRecipientToEp recipient={recipient} refresh={refresh} />)
          }
        />
      )}
      {!isSaving && (
        <SuspensionRemobilisationButton
          recipient={recipient}
          onClick={() =>
            openModal(<DemanderSuspensionRemobilisationModal recipient={recipient} refresh={refresh} />)
          }
        />
      )}
      {lastOrientation && procedureFree && (
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={() =>
            openModal(<AddRecipientToCrossInterview recipient={recipient} onSaved={() => refresh()} />)
          }
        >
          <i className="fa fa-user-tag mr-2" aria-hidden="true" />
          Demander une réorientation
        </button>
      )}
      {PARTNERS_MUTATION_ALLOWED.includes(lastOrientation) &&
        lastOrientation !== organizationAfterMutation?.code &&
        procedureFree &&
        canMutate && (
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={() =>
              openModal(
                <MutationModal
                  recipient={recipient}
                  onSaved={() => refresh()}
                  organizationMutationAllowed={organizationAfterMutation}
                />
              )
            }
          >
            <i className="fa fa-user-tag mr-2" aria-hidden="true" />
            Muter vers une autre Mission Locale
          </button>
        )}
      {!recipient.isActivated && recipient.id && (
        <div data-priv="resend_recipient_activation">
          <button type="button" className="btn btn-outline-primary btn-sm" onClick={resendActivationMail}>
            <i className="fa fa-envelope mr-2" aria-hidden="true" />
            Renvoyer l'email d'activation
          </button>
        </div>
      )}
      <div data-priv="unlock_recipient">
        <button type="button" className="btn btn-ghost btn-sm" onClick={unlockAccount}>
          <i className="fa fa-unlock mr-2" aria-hidden="true" />
          Débloquer le compte
        </button>
      </div>
      {recipient.id && recipient.lastOrientation && (
        <ForceSynchroFTButton
          categorie="ORIENTATION"
          entiteId={recipient.id}
          label="Resynchroniser l'orientation"
          onSuccess={onSynchroForced}
        />
      )}
      {!isModal && recipient.spouse && (
        <a
          className="btn btn-ghost btn-sm"
          href={"/recipients/" + recipient.spouse}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-user-o mr-2" aria-hidden="true" />
          Voir le/la conjoint(e)
        </a>
      )}
    </>
  );
};

export default RecipientActions;
